import { Component } from '@angular/core';
import { SeoService } from './seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'veneta';

  // Inyectado únicamente para activar la suscripción a la navegación
  // que actualiza el canonical y og:url en cada cambio de ruta.
  constructor(private seoService: SeoService) {}

}
